<template>
    <BasePanel
        headline="lang_LABEL_RELEASES_PANEL_CAPTION_PROMOTIONAL_TEXTS"
        :alvqa="alvqa"
    >
        <template v-slot:panelContent>
            <v-data-table
                :headers="headers"
                :items="listItems"
                hide-default-footer
                :header-props="{ sortIcon: '' }"
                :no-data-text="$t('lang_GENERAL_MESSAGE_NO_RECORDS_FOUND')"
                :items-per-page="100"
                class="noMinWidth"
            >
            <!-- Headers -->
                <template v-for="(header, i) in headers" v-slot:[`header.${header.value}`]>
                    <span :alvqa="header.alvqa" :key="i">{{ header.text }}</span>
                </template>

            <!-- Items -->
                <template v-slot:[`item.description`]="{ item }">
                    <div :alvqa="alvqa + '-list-row-text-description'">
                        {{ item.description }}
                    </div>
                </template>
                <template v-slot:[`item.type`]="{ item }">
                    <div :alvqa="alvqa + '-list-row-text-type'">
                        {{ $t(getType(item.type)) }}
                    </div>
                </template>
                <template v-slot:[`item.language`]="{ item }">
                    <div :alvqa="alvqa + '-list-row-text-long-language'">
                        {{ $t(getLanguage(item.language)) }}
                    </div>
                </template>
            </v-data-table>
        </template>
    </BasePanel>
</template>
 
 <script>
 import BasePanel from "@/components/_base/BasePanel"
 import { DropdownLabelReleasesPromotionalTextType } from '@/assets/dropdowns/alvDropdowns.js'

 export default {
    name: "ReleasePromotionalTextsReadOnlyPanel",
    components: {
        BasePanel
    },
    props: {
        releaseAlvId: {
            type: String
        }
    },
    data() {
        return {
            alvqa: 'label-releases-list-row-' + this.releaseAlvId + '-read-only-panel-promotional-texts'
        }
    },
    computed: {
        headers() {
            return [
                {
                    text: this.$t('lang_LABEL_RELEASE_CAPTION_TYPE'), 
                    align: 'left',
                    value: "type",
                    class: 'text-no-wrap',
                    width: "250px",
                    sortable: false,
                    alvqa: this.alvqa + '-header-type'
                },
                {
                    text: this.$t('lang_LABEL_RELEASES_CAPTION_LANGUAGE'), 
                    align: 'left',
                    value: "language",
                    class: 'text-no-wrap',
                    width: "150px",
                    sortable: false,
                    alvqa: this.alvqa + '-header-language'
                },
                {
                    text: this.$t('lang_LABEL_RELEASES_CAPTION_DESCRIPTION'), 
                    align: 'left',
                    value: "description",
                    class: 'text-no-wrap',
                    sortable: false,
                    alvqa: this.alvqa + '-header-description'
                },
            ]
        },

        listItems() { 
            let item = this.$store.getters.getExpandedLabelReleases.find(element => {
                return element.alvId === this.releaseAlvId
            })

            let texts = item.promotionalTexts === null ? [] : item.promotionalTexts
            return texts
        }
    },
    methods: {
        getLanguage(langugeValue) {
            let languges = this.$store.getters.getGeneralLanguages

            if(languges !== undefined) {
                return languges.find(language => {
                    return language.value === langugeValue
                }).text
            }
        },
        getType(typeValue) {
            let typeMatch = DropdownLabelReleasesPromotionalTextType.find(type => {
                return type.value === typeValue
            })

            if(typeMatch !== undefined) return typeMatch.text
        }
    }
 }
 </script>

 <style>
    .noMinWidth table {
        min-width: 0px !important;
    }
</style>